<mat-slider class="w-full mt-5 mb-2 relative"
            [discrete]="false"
            [showTickMarks]="true"
            [disabled]="isDisabled"
            [min]="0"
            [max]="8"
            [displayWith]="formatSliderLabel">
  <div class="labels">
    @for (label of fuelValues; track $index) {
      <div class="label label-medium w-12 text-center"
           tabindex="{{ $index }}"
           (click)="valueNumber = $index"
           (keydown)="valueNumber = $index"
           [ngClass]="{ selected: valueNumber === $index }">
        {{ 'yardControl.lists.fuelLevel.' + label | translate }}
      </div>
    }
  </div>
  <input matSliderThumb aria-label="Fuel Level" [(value)]="valueNumber" />
</mat-slider>
